import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';

import { monthNames } from '../../../utils/typeConstants';
import { useGetCoachingEmpScorecardsQuery } from './metricsSlice';

interface MetricFilter {
    onScorecardChange: (selectedOption: number) => void;
    setScorecardVersionId: React.Dispatch<React.SetStateAction<number>>
    inputYear?: number;
    inputMonth?: number;
    recipientId?: string;
    inputScorecardId?: number;
}

const MetricFilter = (props: MetricFilter) => {
    const [selectedScorecard, setSelectedScorecard] = useState<number | string>('');
    const { data: scorecardData } = useGetCoachingEmpScorecardsQuery(
        {
            employeenumber: props.recipientId,
            year: props.inputYear,
            month: props.inputMonth,
        },
        { skip: !props.recipientId }
    );

    useEffect(() => {
        if (scorecardData?.data.length === 1) {
            setSelectedScorecard(props?.inputScorecardId && props?.inputScorecardId > 0 ? props?.inputScorecardId : scorecardData?.data[0]?.scorecard_id)
            props.onScorecardChange(props?.inputScorecardId && props?.inputScorecardId > 0 ? props?.inputScorecardId : scorecardData?.data[0]?.scorecard_id);
            props.setScorecardVersionId(scorecardData?.data[0]?.scorecard_version_id);
        }
    }, [scorecardData])

    const handleScorecardChange = (e: any) => {
        setSelectedScorecard(e.value);
        props.onScorecardChange(e.value);
        const matchedScorecard = scorecardData?.data?.find(
            (sc: any) => sc.scorecard_id === e.value
        );
        if (matchedScorecard) {
            props.setScorecardVersionId(matchedScorecard.scorecard_version_id);
        }
    };

    return (
        <div className="row MetricFilter">
            <div className="col-md-3">
                <div className="content">
                    <label style={{ margin: '5px' }} htmlFor="calender">
                        Month
                    </label>
                    <label style={{ margin: '5px' }} htmlFor="calender">
                        {props.inputMonth !== undefined && monthNames[props.inputMonth]}, {props.inputYear}
                    </label>
                </div>
            </div>
            <div className="col-md-3">
                <div className="content">
                    <label style={{ margin: '5px' }} htmlFor="scorecardId">
                        Scorecard
                    </label>
                    <Dropdown
                        optionLabel={'scorecard_name'}
                        id="scorecardId"
                        optionValue={'scorecard_id'}
                        onChange={handleScorecardChange}
                        value={selectedScorecard}
                        placeholder="Select Scorecard"
                        options={scorecardData?.data}
                        className="custom-dropdown"
                    />
                </div>
            </div>
            <div className="col-md-3">&nbsp;</div>
        </div>
    );
};

export default MetricFilter;
